import { render, staticRenderFns } from "./CampaignName.vue?vue&type=template&id=3b820214&scoped=true&"
import script from "./CampaignName.vue?vue&type=script&lang=js&"
export * from "./CampaignName.vue?vue&type=script&lang=js&"
import style0 from "./CampaignName.vue?vue&type=style&index=0&id=3b820214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b820214",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b820214')) {
      api.createRecord('3b820214', component.options)
    } else {
      api.reload('3b820214', component.options)
    }
    module.hot.accept("./CampaignName.vue?vue&type=template&id=3b820214&scoped=true&", function () {
      api.rerender('3b820214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/weeklylogin/campaign/components/CampaignName.vue"
export default component.exports